class CV {
  constructor() {
    this.cvs = document.querySelectorAll('.lc-cv-item');

    this.cvs.forEach(cv => {
      this.setupCV(cv);
    });
  }

  setupCV(cv) {
    const button = cv.querySelector('.lc-cv-item__button');
    const contentContainer = cv.querySelector('.lc-cv-item__content');
    const cloneContentContainer = contentContainer.cloneNode(true);
    const contentContainerHtml = contentContainer?.innerHTML;
    const moreContentContainer = cv.querySelector('.lc-cv-item__content-more');
    const moreContentContainerHtml = moreContentContainer?.innerHTML;
    let cvDefaultHeight = contentContainer.clientHeight;
    contentContainer.style.height = cvDefaultHeight + 'px';
    contentContainer.innerHTML = contentContainerHtml + moreContentContainerHtml;

    // udpate container height
    window.addEventListener('resize', () => {
      contentContainer.style.height = '';
      contentContainer.innerHTML = contentContainerHtml;
      cvDefaultHeight = contentContainer.clientHeight;
      contentContainer.innerHTML = contentContainerHtml + moreContentContainerHtml;

      if (!cv.classList.contains('open')) {
        contentContainer.style.height = cvDefaultHeight + 'px';
      } else {
        contentContainer.style.height = contentContainer.scrollHeight + 'px';
      }
    });

    button?.addEventListener('click', (e) => {
      // close logic
      if (cv.classList.contains('open')) {
        cv.classList.remove('open');
        contentContainer.style.height = cvDefaultHeight + 'px';
        return;
      }


      // open logic
      cv.classList.add('open');
      contentContainer.style.height = contentContainer.scrollHeight + 'px';
      return;
    });
  }
}

export default CV;